<script lang="ts">
import { OutboundLink } from '@cf/ui-lib';

export let label: string | unknown;
export let href: string = '';
</script>

<OutboundLink
	href={href}
	target="_blank"
	class="font-medium text-primary hover:underline dark:text-blue-500"
>
	{label}
</OutboundLink>
